import { c as _c } from "react/compiler-runtime";
import { NotificationMenu } from 'modules/notifications/components/notifications-menu';
import React from 'react';
import DesktopMenuItem from 'shared/components/header/components/desktop-menu/components/desktop-menu-item';
import DesktopMenuSkeleton from 'shared/components/header/components/desktop-menu/components/desktop-menu-skeleton';
import { useMenuItems } from 'shared/components/header/hooks/use-menu-items';
import useUser from 'shared/hooks/use-user';
export function DesktopMenu() {
  const $ = _c(6);
  const {
    isLoading,
    user
  } = useUser();
  const {
    menuItems,
    isReady
  } = useMenuItems();
  if (isLoading || !isReady) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <DesktopMenuSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  } else {
    if (!user) {
      return null;
    }
  }
  let t0;
  if ($[1] !== menuItems) {
    t0 = menuItems.map(_temp);
    $[1] = menuItems;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <NotificationMenu />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <div className="flex h-full items-center gap-4">{t0}{t1}</div>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp(item, idx) {
  return <DesktopMenuItem key={idx} item={item} />;
}